import { assert_true } from '@shared/asserts/utils_asserts';
import { FIELD__base } from '../../_base/FIELD__base';

export function DECORATOR__field_is_input() {
  return function (method_original: Function, context: ClassMethodDecoratorContext) {
    return function (this: FIELD__base, ...args: any[]) {
      assert_true(this.meta.kind__is_input);
      return method_original.apply(this, args);
    };
  };
}
